"use client";

import { useEffect, useState } from "react";
import { PERSONALIZATION_RESEND_ACTION_CLASS_NAME } from "../../personalization.constants";
import {
  CONTACT_RESEND_SECONDS,
  CONTACT_TIMER_INTERVAL_MS,
} from "../verification/verification.constants";
import type { EmailLinkSentStepProps } from "../verification/verification.types";

export function EmailLinkSentStep({
  email,
  isRequestingCode,
  onResend,
}: EmailLinkSentStepProps) {
  const [wait, setWait] = useState(CONTACT_RESEND_SECONDS);
  useEffect(() => {
    if (!wait || isRequestingCode) return;
    const timer = window.setTimeout(
      () => setWait((value) => value - 1),
      CONTACT_TIMER_INTERVAL_MS,
    );
    return () => window.clearTimeout(timer);
  }, [wait, isRequestingCode]);

  return (
    <div className="space-y-4">
      <p role="status" className="text-sm text-[#667085]">
        {isRequestingCode
          ? "Sending your email verification link..."
          : `Open the verification link sent to ${email}. You can continue on the device where you open it.`}
      </p>
      <button
        type="button"
        className={PERSONALIZATION_RESEND_ACTION_CLASS_NAME}
        disabled={isRequestingCode || wait > 0}
        onClick={() => {
          setWait(CONTACT_RESEND_SECONDS);
          onResend();
        }}
      >
        {wait ? `Resend email link in ${wait}s` : "Resend email link"}
      </button>
    </div>
  );
}
